import type { ReportButtonLabels } from '../../report-button-content';

export const reportButton: ReportButtonLabels = {
  report: 'Denunciar esta páxina',
  title: 'Informar dun problema nesta páxina',
  reasons: {
    'inaccurate-or-fabricated': 'Información inexacta ou inventada',
    'wrong-product': 'Os produtos non se corresponden coa páxina',
    'sexually-explicit': 'Contido sexualmente explícito',
    'regulated-product': 'Produto con receita ou regulado',
    'dangerous-product': 'Produto perigoso',
    'ip-infringement': 'Vulnera os meus dereitos (marca/dereitos de autor)',
    other: 'Outra cousa',
  },
  detail: 'Detalles (opcional)',
  submit: 'Enviar a denuncia',
  cancel: 'Cancelar',
  sent: 'Grazas. Revisamos as denuncias nun prazo de 24 horas.',
  failed: 'Non se puido enviar a denuncia. Ténteo de novo.',
};
